export function PersonModalTickSVG() {
    return (
        <svg
            data-testid="PersonModalTickSVG"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 1.23529L6.72727 0L3.09091 3.52941L1.27273 1.76471L0 3L3.09091 6L8 1.23529Z"
                fill="white"
            />
        </svg>
    );
}
